import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useStyles } from '../CaseDiagnosisStyles'
import { RootState } from '../../../reducers'
import InlineDropdownDiagnosis from './InlineDropdownDiagnosis'
import { addListData, setSaveState } from '../../../actions'
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp'
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown'
import EditIcon from '@mui/icons-material/Edit'
import { Tooltip, Icon } from '@mui/material'

export default function CommentsSelected({ item, index, location }): JSX.Element | null {
  const [isEdit, setIsEdit] = useState(false)
  const [editIconEnable, setEditIconEnable] = useState(
    item.subOptions && item.displayValue === undefined ? false : true,
  )
  const classes = useStyles()
  const editDivNode = useRef({} as any)
  const dispatch = useDispatch()
  const [currentList, setCurrentList] = useState([] as any)
  const selectedOptions = useSelector((state: RootState) => state.setReportDiagnosisData)
  const selectedCategorizedOptions = useSelector((state: RootState) => state.setCategorizedData)
  const editIconColor = () =>
    editIconEnable ? (isEdit ? `${classes.enableEdit}` : `${classes.removeBtn}`) : `${classes.disabledIcon}`

  useEffect(() => {
    setCurrentList(selectedOptions.payload)
    for (let i = 0; i < selectedOptions.payload.length; i++) {
      const currentSelectedOption = selectedOptions.payload[i]
      if (
        (!currentSelectedOption.displayValue ||
          (currentSelectedOption.displayValue && currentSelectedOption.displayValue.indexOf('-1') !== -1)) &&
        currentSelectedOption.label.indexOf('[') !== -1
      ) {
        if (
          currentSelectedOption.subOptions &&
          currentSelectedOption.selectedSuboptions &&
          currentSelectedOption.label.split('[').length - 1 ===
            Object.keys(currentSelectedOption.selectedSuboptions).length
        ) {
          dispatch(setSaveState({ isSaveDisabled: false }))
        } else {
          dispatch(setSaveState({ isSaveDisabled: true }))
          break
        }
      }
    }
  }, [selectedOptions, currentList])

  const getSelectedBlockClass = () => (isEdit ? `${classes.editSelectedBlock}` : `${classes.selectedBlock}`)
  const getSelectedCommentClass = () =>
    item.callout_required ? `${classes.calloutComment}` : `${classes.generalComment}`
  const getUpClass = () => (index === 0 ? `${classes.disabledIcon}` : `${classes.removeBtn}`)
  const getDownClass = () =>
    index === selectedCategorizedOptions.payload[item.category].length - 1
      ? `${classes.disabledIcon}`
      : `${classes.removeBtn}`

  const setFocus = () => {
    const selection = window.getSelection()
    const range = document.createRange()
    selection && selection.removeAllRanges()
    range.selectNodeContents(editDivNode.current)
    range.collapse(false)
    selection && selection.addRange(range)
    editDivNode.current.focus()
  }

  useEffect(() => {
    if (isEdit) {
      setFocus()
    }
  }, [isEdit])

  const handleSelectDiagnosis = (obj, e) => {
    const optionCategory = obj.label.substring(obj.label.indexOf('['), obj.label.indexOf(']') + 1)
    const selectObj = currentList.find((list1) => list1.id === obj.id)
    const prevObj = currentList.find((o) => Object.values(o).includes(selectObj.label))

    if (prevObj.selectedSuboptions === undefined) prevObj.selectedSuboptions = {}
    prevObj.selectedSuboptions[optionCategory] = e.target.value
    const updateIndex = currentList.findIndex((o) => o.id === prevObj.id)
    currentList[updateIndex] = prevObj
    dispatch(addListData(currentList, true))
    if (prevObj.label.split('[').length - 1 === Object.keys(prevObj.selectedSuboptions).length) setEditIconEnable(true)
    /*     dispatch(setSaveState({ isSaveDisabled: false }))
     */
  }

  const handleDiagnoseListRemove = async () => {
    /*  setEditSave(true) //When deleted the save button will be enabled and later be checked for other comments for the save to be disabled */
    //the display value should be null for the report comments once deleted

    let prevValue = ''
    const commList = selectedCategorizedOptions.payload[item.category]
    prevValue = commList[index].label
    commList[index].displayValue = ''
    //Can merge both in a single loop
    currentList.map((listItem, listIndex) => {
      if (commList[index].id === listItem.id) {
        currentList[listIndex] = commList[index]
      }
    })

    currentList.map((listItem, itemIndex) => {
      if (listItem.id === item.id) {
        currentList.splice(itemIndex, 1)
      }
    })

    dispatch(addListData(currentList, true))
    await dispatch(setSaveState({ isSaveDisabled: false }))
  }

  const moveArrayItemToNewIndex = (arr, old_index, new_index) => {
    if (new_index >= arr.length) {
      let k = new_index - arr.length + 1
      while (k--) {
        arr.push(undefined)
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0])
    return arr
  }

  const moveUp = async (index) => {
    if (index > 0) {
      const currentArray = moveArrayItemToNewIndex(selectedCategorizedOptions.payload[item.category], index, index - 1)
      const currentSection = selectedCategorizedOptions.payload
      currentSection[item.category] = currentArray
      // dispatch(addListData(currentSection, false))
      let updatedIndex = 0
      for (let x = 0; x < selectedOptions.payload.length; x++) {
        if (selectedOptions.payload[x].id === item.id) {
          updatedIndex = x
          break
        }
      }
      const flatArray = move(updatedIndex)
      await dispatch(addListData(flatArray, true))
      await dispatch(setSaveState({ isSaveDisabled: false }))

      /*       setEditSave(true)
       */ // setListChanged(true)
    }
  }

  const move = (index) => {
    const array = selectedOptions.payload
    const elm = array.splice(index, 1)[0]
    array.splice(index - 1, 0, elm)
    return array
  }

  const moveDown = async (index) => {
    if (index < currentList.length - 1) {
      const currentArray = moveArrayItemToNewIndex(selectedCategorizedOptions.payload[item.category], index, index + 1)
      const currentSection = selectedCategorizedOptions.payload
      currentSection[item.category] = currentArray
      // dispatch(addListData(currentSection, false))
      let updatedIndex = 0
      for (let x = 0; x < selectedOptions.payload.length; x++) {
        if (selectedOptions.payload[x].id === item.id) {
          updatedIndex = x
          break
        }
      }
      const flatArray = moveD(updatedIndex)
      await dispatch(addListData(flatArray, true))
      /*       setEditSave(true)
       */ // setListChanged(true)
      await dispatch(setSaveState({ isSaveDisabled: false }))
    }
  }

  const moveD = (index) => {
    const array = selectedOptions.payload
    const elm = array.splice(index, 1)[0]
    array.splice(index + 1, 0, elm)
    return array
  }

  const checkValue = (value) => {
    // const value = item.displayValue ? item.displayValue : item.label
    return value.indexOf('[') !== -1
  }

  const checkItemValue = (item) => {
    const value = item.displayValue ? item.displayValue : item.label
    return value.indexOf('[') !== -1
  }

  const handleCommentFlatten = async (item) => {
    //should onlu be called when both the options are selected
    //should flatten only that comment
    let flattenedString = item.label
    const selectedSuboptionValues = Object.values(item.selectedSuboptions)
    const selectedSuboptionKeys = Object.keys(item.selectedSuboptions)
    selectedSuboptionKeys.forEach((element, index) => {
      flattenedString = flattenedString.replace(element, selectedSuboptionValues[index])
    })
    item.displayValue = flattenedString
    //await dispatch(addListData([...selectedOptions.payload, item], true))
  }

  const handleEdit = (event, item, index) => {
    if (
      item.subOptions &&
      item.selectedSuboptions &&
      (!item.displayValue || (item.displayValue && item.displayValue.indexOf('-1') !== -1))
    ) {
      if (item.label.split('[').length - 1 === Object.keys(item.selectedSuboptions).length) {
        handleCommentFlatten(item)
        setIsEdit(true)
        setFocus()
      } else {
        setIsEdit(false)
      }
    } else {
      setIsEdit(true)
      setFocus()
    }
  }

  const handleTextChange = async (event, index) => {
    const newValue = event.target.outerText
    let prevValue = ''
    const commList = selectedCategorizedOptions.payload[item.category]
    if (isEdit) {
      prevValue = commList[index].label
      commList[index].displayValue = newValue
      currentList.map((listItem, listIndex) => {
        if (commList[index].id === listItem.id) {
          currentList[listIndex] = commList[index]
        }
      })
      if (prevValue.localeCompare(newValue) !== 0) {
        await dispatch(setSaveState({ isSaveDisabled: false }))
      }
      dispatch(addListData(currentList, true))
    }
    setIsEdit(false)
  }

  return (
    <>
      <div key={index}>
        <div
          contentEditable={isEdit}
          onBlur={() => handleTextChange(event, index)}
          className={getSelectedBlockClass()}
          ref={editDivNode}
        >
          <p className={getSelectedCommentClass()}>
            {checkItemValue(item) ? (
              <InlineDropdownDiagnosis
                obj={item}
                handleSelectDiagnosis={handleSelectDiagnosis}
                setEditIconEnable={setEditIconEnable}
              />
            ) : item.displayValue ? (
              item.displayValue
            ) : (
              item.label
            )}
          </p>
          {/* 
          
          {isSaveClicked == false && !checkValue(item.label) && item.label}
          {isSaveClicked == false && checkValue(item.label) && (
            <InlineDropdownDiagnosis obj={item} handleSelectDiagnosis={handleSelectDiagnosis} />
          )} */}
        </div>
        <div className={classes.removeBtn} onClick={(item1) => handleDiagnoseListRemove()}>
          <Tooltip title="Delete" placement="bottom-start">
            <Icon>delete_outlined</Icon>
          </Tooltip>
        </div>
        <div className={getDownClass()} onClick={() => moveDown(index)}>
          <ArrowCircleDownIcon />
        </div>
        <div className={getUpClass()} onClick={() => moveUp(index)}>
          <ArrowCircleUpIcon />
        </div>
        {item.is_editable && editIconEnable !== undefined && (
          <div className={editIconColor()} onClick={(event) => handleEdit(event, item, index)}>
            <Tooltip title="Edit the comment" placement="bottom-start">
              <EditIcon />
            </Tooltip>
          </div>
        )}
      </div>
    </>
  )
}
